import React, { Component, Fragment } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';

import { hlog } from '../../common/util';
import { resendVerification } from '../../actions';
import AccountVerified from '../../common/accountVerified';

class EventDetailAllTeamsWarningMessage extends Component {
  state = { hasResentVerification: false };

  handleSendVerification = e => {
    e.preventDefault();
    this.props
      .resendVerification()
      .then(() => {
        this.setState({ hasResentVerification: true });
      })
      .catch(res => {
        hlog(res);
      });
  };

  render() {
    const { user, translate } = this.props;
    const { hasResentVerification } = this.state;

    return (
      <AccountVerified>
        { ({ verified }) => (
          <Fragment>
            { !verified && (
              <div className='eventDetail_projects_emailVerifiedMessage'>
                { hasResentVerification ? (
                  <Message warning>
                    <Message.Header>{translate('text.pleaseCheckInbox')}</Message.Header>
                  </Message>
                ) : (
                  <Message negative icon className='one-more-step-message'>
                    <Icon name='mail' />
                    <Message.Content>
                      <Message.Header>{translate('text.oneMoreStepAway')}</Message.Header>
                      <div>
                        {translate('text.weSentConfirmationEmail', { email: user.profile.basicInfo.email })}
                        <a onClick={this.handleSendVerification}> {translate('button.sendAgain')}</a>
                      </div>
                    </Message.Content>
                  </Message>
                ) }
              </div>
            ) }
          </Fragment>
        ) }
      </AccountVerified>
    );
  }
}

export default compose(
  withLocalize,
  connect(
    ({ user }) => ({ user }),
    { resendVerification }
  )
)(EventDetailAllTeamsWarningMessage);



// WEBPACK FOOTER //
// ./src/components/events/components/eventDetailAllTeamsWarningMessage.js